import {notice} from "/assets/js/utils/notices";
import {applyPhoneMask} from "/assets/js/utils/phone-mask";

class Checkout {
    form;
    submitOrderBtn;
    fullNameInput;
    firstNameInput;
    lastNameInput;
    phoneInput;
    emailInput;
    termsAgreement;
    policyAgreement;

    constructor(elm) {
        this.form = elm;
        this.submitOrderBtn = this.form.querySelector('#place_order') || this.form.querySelector('.checkout__right-form-item--submit');
        this.fullNameInput = this.form.querySelector('[name="billing_full_name"]');
        this.firstNameInput = this.form.querySelector('[name="billing_first_name"]');
        this.lastNameInput = this.form.querySelector('[name="billing_last_name"]');
        this.phoneInput = this.form.querySelector('[name="billing_phone"]');
        this.emailInput = this.form.querySelector('[name="billing_email"]');
        this.termsAgreement = this.form.querySelector('[name="terms"]');
        this.policyAgreement = this.form.querySelector('[name="policy"]');

        this.init();
    }

    init() {
        this.submitOrderBtn.addEventListener('click', this._submitOrder)

        this.fullNameInput.addEventListener('input', this._fieldChanged);
        this.phoneInput.addEventListener('input', applyPhoneMask);
        this.phoneInput.addEventListener('input', this._fieldChanged);
        this.emailInput.addEventListener('input', this._fieldChanged);

        this.termsAgreement.addEventListener('click', this._fieldChanged);
        this.policyAgreement.addEventListener('click', this._fieldChanged);
    }

    _submitOrder = async (e) => {
        e.preventDefault();

        let formValidated = true;
        let firstInvalidNotice = false;

        if (this.fullNameInput.value == '') {
            this.fullNameInput.classList.add('invalid');
            if (!firstInvalidNotice) {
                notice('Введите Имя и фамилию', 'error');
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            this.fullNameInput.classList.remove('invalid');
        }

        if (!this.validatePhone(this.phoneInput.value)) {
            this.phoneInput.classList.add('invalid');
            if (!firstInvalidNotice) {
                notice('Введите номер телефона', 'error');
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            this.phoneInput.classList.remove('invalid');
        }

        if (!this.validateEmail(this.emailInput.value)) {
            this.emailInput.classList.add('invalid');
            if (!firstInvalidNotice) {
                notice('Введите Email', 'error');
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            this.emailInput.classList.remove('invalid');
        }

        if (!this.policyAgreement.checked) {
            const checkElm = this.policyAgreement.nextElementSibling; 
            checkElm.classList.add('invalid');
            if (!firstInvalidNotice) {
                notice('Подтвердите согласие c политикой конфиденциальности', 'error');
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            const checkElm = this.policyAgreement.nextElementSibling; 
            checkElm.classList.remove('invalid');
        }

        if (!this.termsAgreement.checked) {
            const checkElm = this.termsAgreement.nextElementSibling; 
            checkElm.classList.add('invalid');
            if (!firstInvalidNotice) {
                notice('Подтвердите согласие c публичной офертой', 'error');
                firstInvalidNotice = true;
            }
            formValidated = false;
        } else {
            const checkElm = this.termsAgreement.nextElementSibling; 
            checkElm.classList.remove('invalid');
        }

        if (!formValidated) {
            return;
        }

        // Добавляем прелоадер
        if (this.submitOrderBtn) {
            this.submitOrderBtn.classList.add('is-loading');
        }

        this.parseFullNameInput();
        const formData = new FormData(this.form);

        fetch(`${backendData.siteUrl}?wc-ajax=checkout`, {
            method: 'POST',
            body: formData,
        })
        .then(resp => resp.json())
        .then(data => {
            if (data.redirect) {
                window.location.href = data.redirect;
            }

            if (data.messages) {
                notice(data.messages, data.result === 'success' ? 'default' : 'error');
                // Убираем прелоадер при ошибке
                if (this.submitOrderBtn) {
                    this.submitOrderBtn.classList.remove('is-loading');
                }
            }
        })
        .catch(() => {
            // Убираем прелоадер при ошибке
            if (this.submitOrderBtn) {
                this.submitOrderBtn.classList.remove('is-loading');
            }
        });
    }

    _fieldChanged = (e) => {
        const input = e.target;

        if ((input.getAttribute('name') == 'billing_full_name') && input.value != '') {
            input.classList.remove('invalid');
        }

        if ((input.getAttribute('name') == 'billing_phone') && this.validatePhone(input.value)) {
            input.classList.remove('invalid');
        }

        if ((input.getAttribute('name') == 'billing_email') && this.validateEmail(input.value)) {
            input.classList.remove('invalid');
        }

        if (
            (
                (input.getAttribute('name') == 'policy') ||
                (input.getAttribute('name') == 'terms')
            ) &&
            input.checked
        ) {
            const checkElm = input.nextElementSibling; 
            checkElm.classList.remove('invalid');
        }
    }

    parseFullNameInput() {
        const nameParts = this.fullNameInput.value.split(/\s+/);
        this.firstNameInput.value = nameParts[0] || '';
        this.lastNameInput.value = nameParts[1] || '';
    }

    validatePhone(phone) {
        if (!phone) return false;

        const cleaned = phone.replace(/[^\d+]/g, '');

        // от 10 до 15 цифр (международный формат)
        return /^\+?\d{10,15}$/.test(cleaned);
    }

    validateEmail(email) {
        if (!email) return false;

        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elm = document.querySelector('.checkout__wrapper');
    if (elm) {
        new Checkout(elm);
    }
});